import React, { useState } from "react";
import { SearchInput } from "@toddle-edu/ds-web";
import classes from "./SearchInputWrapper.scss";

const SearchInputWrapper = ({
  searchText,
  updateSearchText,
  placeholder,
  isCompactUINeeded,
}) => {
  const [searchValue, setSearchValue] = useState(searchText);
  const searchContainterClass = isCompactUINeeded
    ? classes.searchBoxContainerProject
    : classes.searchBoxContainer;

  const updateSearchValue = value => {
    setSearchValue(value);
    updateSearchText(value);
  };

  return (
    <div className={searchContainterClass}>
      <SearchInput
        size="medium"
        value={searchValue}
        onChange={updateSearchValue}
        placeholder={placeholder}
        autoFocus
        dsVersion="2.0"
        focusSearchBySlash
      />
    </div>
  );
};

SearchInputWrapper.defaultProps = {
  placeholder: "search",
  isProjectNode: false,
};

export default SearchInputWrapper;
